import { render, staticRenderFns } from "./InvoiceBody.vue?vue&type=template&id=acbbf7f2&scoped=true&"
import script from "./InvoiceBody.vue?vue&type=script&lang=js&"
export * from "./InvoiceBody.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBody.vue?vue&type=style&index=0&id=acbbf7f2&prod&lang=scss&scoped=true&"
import style1 from "./InvoiceBody.vue?vue&type=style&index=1&id=acbbf7f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbbf7f2",
  null
  
)

export default component.exports